
export const formatDateTime = (date: string): string => {
    try {
        const dateFormatted = new Date(date);

        if (String(dateFormatted) === 'Invalid Date' || date.includes('/')) {
            throw new Error('');
        }
        const year = dateFormatted.getFullYear();

        const day = dateFormatted.getDate() > 9
            ? dateFormatted.getDate() : `0${dateFormatted.getDate()}`;

        const month = dateFormatted.getMonth() + 1 > 9
            ? dateFormatted.getMonth() + 1 : `0${dateFormatted.getMonth() + 1}`;

        const hour = dateFormatted.getHours() > 9
            ? dateFormatted.getHours() : `0${dateFormatted.getHours()}`;

        const minute = dateFormatted.getMinutes() > 9
            ? dateFormatted.getMinutes() : `0${dateFormatted.getMinutes()}`;

        const seconds = dateFormatted.getSeconds() > 9
            ? dateFormatted.getSeconds() : `0${dateFormatted.getSeconds()}`;

        if (!isNaN(Number(day))) {
            return `${day}/${month}/${year} ${hour}:${minute}:${seconds}`;
        }
        else {
            return date;
        }
    }
    catch (error) {
        return '';
    }
};

export function formatDateUs(date: any) {
    const localDate = new Date(date);

    const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(localDate);
    const month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(localDate);
    const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(localDate);

    return (
        new Date(`${year}-${month}-${day}`)
    );
}

export function formatLongDate(date: any) {
    const localDate = new Date(date);

    const dateNow = new Date(localDate.getUTCFullYear(), localDate.getUTCMonth(), localDate.getUTCDate());

    return (
        dateNow
    );
}

export const formatDate = (date: string): string => {
    try {
        const dateFormatted = new Date(date);

        if (String(dateFormatted) === 'Invalid Date' || date.includes('/')) {
            throw new Error('');
        }
        const year = dateFormatted.getFullYear();

        const day = dateFormatted.getDate() > 9
            ? dateFormatted.getDate() : `0${dateFormatted.getDate()}`;

        const month = dateFormatted.getMonth() + 1 > 9
            ? dateFormatted.getMonth() + 1 : `0${dateFormatted.getMonth() + 1}`;

        if (!isNaN(Number(day))) {
            return `${day}/${month}/${year}`;
        }
        else {
            return date;
        }
    }
    catch (error) {
        return '';
    }
};

export function formatSecondsToTime(secondsTime: number) {

    const years = Math.floor(secondsTime / (3600 * 24 * 365));
    const months = Math.floor(secondsTime % (3600 * 24 * 365)) / (3600 * 24 * 30);
    const days = Math.floor(secondsTime % (3600 * 24 * 365)) / (3600 * 24);

    const hours = Math.floor(secondsTime / 3600);
    const minutes = Math.floor((secondsTime - (hours * 3600)) / 60);
    const seconds = secondsTime - (hours * 3600) - (minutes * 60);

    const year = years > 0 ? `0${years}y ` : '';
    const month = months > 0 ? `0${months}m ` : '';
    const day = days > 0 ? `0${days}y ` : '';
    const hour = hours > 9 ? hours : `0${hours}`;
    const minute = minutes > 9 ? minutes : `0${minutes}`;
    const second = seconds > 9 ? seconds : `0${seconds}`;

    return (
        year + month + day + hour + ':' + minute + ':' + second
    );
}

export function dateDiff(startDate: string, endDate: string) {

    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();

    const result = (end - start) / 1000;

    return (
        formatSecondsToTime(result)
    );
}